import React, { useState } from 'react'
import { Table } from 'antd'
import { useRequest } from 'ahooks'
import { BaseDialog } from '@/components/dialog/base-dialog'
import $msg from '@/utils/message'
import { getLsMembersImported } from '../api'
import { getMemberTablePagination, getTableTotal, MEMBER_TABLE_PAGE_SIZE } from '../table-utils'

interface Props {
    recordId: number
    onClose: () => void
}

const ImportRecordDetail: React.FC<Props> = ({ recordId, onClose }) => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(MEMBER_TABLE_PAGE_SIZE)
    const req = useRequest(() => getLsMembersImported({ record_id: recordId, page, limit: pageSize }), {
        refreshDeps: [recordId, page, pageSize],
        onError: error => $msg('error', error.message || '获取导入明细失败'),
    })

    return (
        <div className="member-import__detail-layer">
            <BaseDialog isShow title="导入会员明细" width={960} onClose={onClose}>
                <div className="member-import__detail">
                    <div className="member-import__detail-summary">
                        导入时间：{req.data?.record?.create_time || '--'}　成功导入：{req.data?.record?.members_imported ?? '--'} 人
                    </div>
                    <Table
                        bordered
                        rowKey="id"
                        loading={req.loading}
                        columns={[
                            { title: '会员姓名', width: 160, render: (_value, record: any) => record.realname || record.nickname || '--' },
                            { title: '手机号', dataIndex: 'phone', width: 150, render: value => value || '--' },
                            { title: '生日', dataIndex: 'birthday', width: 130, render: value => value || '--' },
                            { title: '余额', dataIndex: 'balance', width: 120 },
                            { title: '积分', dataIndex: 'point', width: 110 },
                            { title: '卡号', dataIndex: 'card_code', width: 150, render: value => value || '--' },
                        ]}
                        dataSource={req.data?.members || []}
                        scroll={{ x: 'max-content' }}
                        pagination={getMemberTablePagination({
                            current: page,
                            pageSize,
                            total: getTableTotal(req.data?.pagination),
                            onChange: setPage,
                            onShowSizeChange: (nextPage, nextSize) => {
                                setPage(nextPage)
                                setPageSize(nextSize)
                            },
                        })}
                    />
                </div>
            </BaseDialog>
        </div>
    )
}

export default ImportRecordDetail
